export const REDUCE_USER_SETTINGS = 'REDUCE_USER_SETTINGS';
export const GET_USER_SETTINGS = 'GET_USER_SETTINGS';
